import { getBadgeText } from "../../../../getBadgeText";
import getPriceInfo from "./getPriceInfo";

const getAriaLabel = ({
  description,
  price,
  reducedPrice,
  isOutlet,
  discount,
  badgeType,
  hasMultiplePrices,
  formatTranslation,
  isSponsored,
  isSellingFast
}) => {
  let sections = [];
  if (isSponsored) {
    sections.push(formatTranslation("sponsored_product_ads"));
  }
  const priceInfo = getPriceInfo({
    price,
    reducedPrice,
    hasMultiplePrices,
    isOutlet,
    formatTranslation
  });
  sections = [...sections, description, priceInfo];
  if (discount) {
    sections.push(
      `${formatTranslation("generic_accessibility_discount")}: -${discount}%`
    );
  }
  if (badgeType) {
    sections.push(getBadgeText({ type: badgeType, formatTranslation }));
  }
  if (isSellingFast) {
    sections.push(formatTranslation("va_selling_fast_label"));
  }

  return sections.join("; ");
};

export default getAriaLabel;
